import {
  type SerializedError,
  createAsyncThunk as createRtkAsyncThunk,
  miniSerializeError
} from '@reduxjs/toolkit';

/**
 * Сериализует ошибку async thunk для Redux store.
 * В отличие от стандартного `miniSerializeError`, сохраняет поля API-ошибки
 * (`messages`, `statusCode`, `isCancelled`), чтобы `handleError` мог их обработать.
 */
export const serializeApiError = (value: unknown): SerializedError => {
  const serialized = miniSerializeError(value);

  if (typeof value !== 'object' || value === null) {
    return serialized;
  }

  const error = value as Error;
  const result: SerializedError = { ...serialized };

  if ('messages' in error && Array.isArray(error.messages)) {
    result.messages = error.messages.filter(
      (item): item is string => typeof item === 'string'
    );
  }

  if ('statusCode' in error) {
    result.statusCode =
      typeof error.statusCode === 'number' ? error.statusCode : undefined;
  }

  if ('isCancelled' in error) {
    result.isCancelled = Boolean(error.isCancelled);
  }

  return result;
};

/**
 * Обёртка над RTK `createAsyncThunk` с сериализатором API-ошибок по умолчанию.
 * Используй её вместо `createAsyncThunk` из `@reduxjs/toolkit`, чтобы
 * `messages`, `statusCode` и `isCancelled` доходили до `handleError`.
 */
export const createAsyncThunk = ((
  typePrefix: string,
  payloadCreator: never,
  options?: object
) =>
  createRtkAsyncThunk(typePrefix, payloadCreator, {
    serializeError: serializeApiError,
    ...options
  })) as typeof createRtkAsyncThunk;
